import RegisterBetaSuccess from "./RegisterBetaSuccess";

export default RegisterBetaSuccess;
